import classes from "./styles.module.scss";

const Loader = () => {
  return (
    <div className={classes.loaderRoot}>
        <div>Loading...</div>
    </div>
  )
}

export default Loader;